import { render, staticRenderFns } from "./PowerpagePinsComponent.vue?vue&type=template&id=126604bc&scoped=true&"
import script from "./PowerpagePinsComponent.vue?vue&type=script&lang=js&"
export * from "./PowerpagePinsComponent.vue?vue&type=script&lang=js&"
import style0 from "./PowerpagePinsComponent.vue?vue&type=style&index=0&id=126604bc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126604bc",
  null
  
)

export default component.exports